import { ILazyActionHandler, ICompressionResult } from 'app/services/rtc/sync/documentmanagers/lazy';
import { SharedSelectionDocumentState } from 'app/models/rtc/selection/constants';
import { selectionReducer } from 'app/models/rtc/selection/reducer';
import { IEncodedSelectionAction } from '@engoo/realtime-protocol/selection';
import { EntityStringId } from 'app/types/entity';
import { ActionState } from 'app/services/rtc/sync/documentmanagers';
import { is } from 'immutable';

export default class SelectionActionHandler
implements ILazyActionHandler<SharedSelectionDocumentState, IEncodedSelectionAction> {
  public constructor(private readonly caller: EntityStringId) {}

  public apply(doc: SharedSelectionDocumentState, action: IEncodedSelectionAction, actionState: ActionState) {
    switch (actionState) {
      case ActionState.Confirmed:
      case ActionState.ConfirmedOutOfOrder:
        return selectionReducer(doc, action);
      case ActionState.Pending:
        return selectionReducer(doc, { ...action, user: this.caller });
    }
  }

  /**
   * Drop all but the last action
   */
  public compress(doc: SharedSelectionDocumentState, actions: Iterable<IEncodedSelectionAction>) {
    const result: ICompressionResult<IEncodedSelectionAction> = {
      compressed: 0,
      action: undefined,
    };

    // Only take the last action
    for (const action of actions) {
      ++result.compressed;
      result.action = action;
    }

    // Don't send redundant actions
    if (result.action && is(doc, this.apply(doc, result.action, ActionState.Pending))) {
      result.action = undefined;
    }

    return [result];
  }
}
